import { render } from "./TreesWin.vue?vue&type=template&id=67d46a0f"
import script from "./TreesWin.vue?vue&type=script&lang=js"
export * from "./TreesWin.vue?vue&type=script&lang=js"

import "./TreesWin.vue?vue&type=style&index=0&id=67d46a0f&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__